import { Button, Page, Stack, Typography } from "@fideus-ui/core";
import { Logout as LogoutIcon } from "@fideus-ui/core/icons";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";

interface AccessRequestedProps {
  onLogout: () => void;
}

export function AccessRequested({ onLogout }: AccessRequestedProps) {
  const t = useTranslation(translations);
  return (
    <Page>
      <Typography variant="h4" gutterBottom>
        {t("accessRequestedTitle")}
      </Typography>
      <Typography>{t("accessRequestedMessage")}</Typography>
      <Stack direction="row" spacing={2}>
        <Button
          variant="outlined"
          onClick={onLogout}
          startIcon={<LogoutIcon />}
        >
          {t("logout")}
        </Button>
      </Stack>
    </Page>
  );
}
